
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5.5c-3.864 0-7 3.136-7 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm.7 11.9H6.8V11h1.4v1.4zm1.449-5.425l-.63.644C8.515 8.13 8.2 8.55 8.2 9.6H6.8v-.35c0-.77.315-1.47.819-1.981l.868-.882c.259-.252.413-.602.413-.987 0-.77-.63-1.4-1.4-1.4-.77 0-1.4.63-1.4 1.4H4.7a2.8 2.8 0 115.6 0c0 .616-.252 1.176-.651 1.575z","fill":"currentColor"}})])
          )
        }
      }
    